module.exports = __webpack_public_path__ + "img/public/SiteIcons/noPayoutMethod.svg?c17a0702";